// src/components/bootstrap-carousel.component.js
import React from "react";
import Product  from "./Product";
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


function BootstrapCarouselComponent(){
  return (
   <div>
   <div className='container-fluid'>
      <div className="row">
       <div className="col-12">

   <Carousel indicators={false}>

    {/* <Carousel.Item interval={3000}>
     <img
      className="d-block w-100 home__image1"
      src="https://m.media-amazon.com/images/I/61FuWeCuGCL._SX3000_.jpg"
      alt="First slide"
     />
     <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div>
   </Carousel.Item> */}

   <Carousel.Item interval={3000}>
    <img
      className="d-block w-100 home__image1"
      src="https://m.media-amazon.com/images/I/61tnZuhwihL._SX3000_.jpg"
      alt="Second slide"
    />
         <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div>
  </Carousel.Item>
  //nothing
  <Carousel.Item interval={3000}>
    <img
      className="d-block w-100 home__image1"
      src="https://m.media-amazon.com/images/I/71LWMB8OAKL._SX3000_.jpg"
      alt="Third slide"
    />
            <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div>
  </Carousel.Item>
  <Carousel.Item interval={3000}>
    <img
      className="d-block w-100 home__image1"
      src="https://m.media-amazon.com/images/I/81RoKL-XM-L._SX3000_.jpg"
      alt="Third slide"
    />
         <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div>
  </Carousel.Item>
  <Carousel.Item interval={3000}>
    <img
      className="d-block w-100 home__image1"
      src="https://m.media-amazon.com/images/I/61SROPzucIL._SX3000_.jpg"
      alt="Third slide"
    />
         <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div>
  </Carousel.Item>
  {/* <div className="home__row1">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/61h908OnLCL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Ruvanti 4 Pcs Full Size Green Bed Sheets, Extra Soft Brushed 1800 Microfiber Sheet Set, Wrinkle Resistant, Breathable, Luxurious, Deep Pocket, Warm, Sheet..."
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/5191zZiD2DL._AC_SL1024_.jpg"
          />
        </div> */}
    </Carousel>
     </div>
      </div>
        </div>
   </div>
  )
 };

export default BootstrapCarouselComponent;

